import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Divider } from "@mui/material";

const TITLE_SX = {
  fontFamily: "'72', Arial, sans-serif",
  fontWeight: 600,
  fontSize: 14,
  pb: 1,
  borderBottom: "1px solid rgba(0,0,0,0.08)",
};

export default function AdminFormDialog({
  open,
  onClose,
  title,
  maxWidth = "sm",
  children,
  onSave,
  saving,
  saveLabel = "Salvar",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{ sx: { borderRadius: 0 } }}
    >
      <DialogTitle sx={TITLE_SX}>{title}</DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          pt: "16px !important",
          "& .MuiInputBase-input, & .MuiSelect-select": {
            fontFamily: "'72', Arial, sans-serif",
            fontSize: 13,
          },
          "& .MuiInputLabel-root": {
            fontFamily: "'72', Arial, sans-serif",
            fontSize: 12,
          },
          "& .MuiFormHelperText-root": {
            fontFamily: "'72', Arial, sans-serif",
            fontSize: 11,
          },
        }}
      >
        {children}
      </DialogContent>

      <Divider sx={{ opacity: 0.5 }} />

      <DialogActions sx={{ px: 2, py: 1.2, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{ textTransform: "none", fontSize: 13, fontWeight: 500 }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving}
          sx={{ textTransform: "none", fontSize: 13 }}
        >
          {saving ? "Salvando..." : saveLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
